const COMMON_ROUTE_PATHS = {
  HOME: '/',
  STATIC_PAGE: '/page/:countryCode/:pageId',
  PRODUCT_STATIC_PAGE: '/page/:countryCode/:productId/:pageId',
}

const ENROLLMENT_ROUTE_PATHS = {
  DECOMMISSIONED_ENROLLMENT: '/enroll/virtual-card',
  ENROLL_CARD: '/enroll',
  BDMC_ENROLL: '/business/enroll/primary',
  BDMC_ENROLL_ADDITIONAL: '/business/enroll/additional',
  PRODUCT_ELIGIBILITY: '/apply', // PPDC and BDMC
  PPCC_LANDING_PAGE: '/new-debit-card',
  SETUP_FUNDING: '/setup-fi',
}

const XO_PPDC_ROUTE_PATHS = {
  XO_PPDC: '/enroll/ppdcxo',
}

const MANAGEMENT_ROUTE_PATHS = {
  SEARCH: '/search',
  SUMMARY: '/summary',
  REWARDS: '/rewards',
  BDMC_RECURRING_PAYMENTS: '/recurring-payments-dashboard',
  BDMC_FAQ: '/faq',
  BDMC_OPTOUT: '/optout',
  FUNDING: '/manage/:cardId/funding',
  FUNDING_PRODUCT: '/manage/:cardId/:product/funding',
  CANCEL_CARD_BY_PRODUCT: '/manage/:cardId/:product/cancel',
  LOW_BALANCE_ALERT_SETTINGS: '/settings/lowbalance',
  CARD_LIMITS: '/card-limits/:cardId',
  BDMC_CANCEL_CARD: '/cancel-card/:cardId',
  BDMC_REPLACE_CARD: '/replace-card/:cardId',
  BDMC_LOST_CARD_POST_STEPUP: '/lost-card-post-stepup/:cardId',
}

const PPCC_ROUTE_PATHS = {
  CHANGE_PIN: '/manage/:cardId/change-pin',
  VIEW_PIN: '/manage/:cardId/view-pin',
  SET_PIN: '/manage/:cardId/create-pin',
  SHOW_CARD: '/manage/:cardId/show-card',
  REQUEST_PHYSICAL_CARD: '/manage/:cardId/request-physical-card',
}

const PAYPAL_KEY_ROUTE_PATHS = {
  CHANGE_CVV: '/manage/:cardId/:product/change-cvv',
  CANCEL_CARD: '/manage/:cardId/cancel',
}

const FWC_ROUTE_PATHS = {
  BDMC_CONFIRM_CARD_ADDRESS: '/confirm-card-address',
  CHANGE_ADDRESS: '/address/change',
  ADD_ADDRESS: '/address/add',
  REPLACE_CARD: '/manage/:cardId/replace',
  ACTIVATE_CARD: '/activate',
  ACTIVATE_CARD_BY_ID: '/activate/:cardId',
}

const FLOW_ROUTE_PATHS = {
  ...PPCC_ROUTE_PATHS,
  ...PAYPAL_KEY_ROUTE_PATHS,
  ...FWC_ROUTE_PATHS,
}

export const CLIENT_ROUTE_PATHS = {
  ...COMMON_ROUTE_PATHS,
  ...ENROLLMENT_ROUTE_PATHS,
  ...MANAGEMENT_ROUTE_PATHS,
  ...FLOW_ROUTE_PATHS,
  ...XO_PPDC_ROUTE_PATHS,
}
